import { initHejiaqinSDK } from '@/utils/hejiaqinSDK';
import Error from "@@/common/Error.vue";
import { showImagePreview } from 'vant';
import MDRouter from "@/service/router";
import env from "md-base-tools/env";
import cont_match_reg from "@/utils/editor.js";
import { observeVideo } from "md-base-tools/editor/gitvideo";
import redirect from "@/service/redirect";
import { mapState } from "vuex";
import domain from "@/service/domain";
import { getSchemeUrl } from "@/utils/toolsApi";
import CompHeader from "@@/project/header.vue";
import CompTopSwiper from "@@/project/topSwiper.vue";
import CompStatus from "@@/project/status.vue";
import CompInitiator from "@@/project/initiator.vue";
import CompAgreement from "@@/project/agreement.vue";
import CompBottomBtn from "@@/project/bottomBtn.vue";
import CompPopupFavor from "@@/project/popup/popupFavor.vue";
import CompProphet from "@@/project/prophet.vue";
import DoubleCols from "@@/home/doubleCols.vue";
import DrawNew from "@@/update/detail/drawNew.vue";
import CompGoalsUnlock from '@@/project/popup/goalsUnlock.vue';
import CompLottieAnimation from "@@/lottieAnimation.vue";
import { getProjectBasicInfo, getProjectBasicInfoRT, getProjectBasicRelateInfo, getProjectBasicDynamicInfo, getProjectBasicContent, getQuestionlist, favorProject, getTeamfundTotal, previewProject, ClickShare, getQueryUserLicenseInfo3c, getProIndexUnlockGoal, clickUserShareProIndex } from "@/api";
import { mdToast, fmoney, QuickCopy } from "../../utils/tools";
// import Clipboard from 'clipboard';
export default {
  components: {
    Error,
    CompHeader,
    CompTopSwiper,
    CompStatus,
    CompInitiator,
    CompAgreement,
    CompBottomBtn,
    CompPopupFavor,
    CompProphet,
    DrawNew,
    CompGoalsUnlock,
    CompLottieAnimation,
    DoubleCols
  },
  computed: {
    ...mapState({
      ifLogin: state => state.user.ifLogin,
      // 是否登录
      userId: state => state.user.userId
      // linkUrl: state => state.user.linkUrl,
    }),
    pro_success() {
      return this.product_info.status_code == 3;
    },
    pro_failed() {
      // 显示失败标识
      return this.product_info.status_code == 2 || this.product_info.status_code == 6 || this.product_info.status_code == 7 || this.product_info.status_code == 8;
    },
    is_preview() {
      return this.$route.query.token ? true : false;
    },
    show_category() {
      let result = false;
      if (this.product_info.category) {
        result = true;
        if (this.rank_info && this.rank_info.rank_tag_name && !this.rank_info.is_total_rank) {
          result = false;
        }
      }
      return result;
    }
  },
  data() {
    return {
      showError: false,
      showMessage: "",
      product_info: {},
      update_info: {},
      user_info: {},
      idea_info: {},
      rank_info: {},
      question_list: [],
      question_total: 0,
      showFavor: false,
      favorType: "success",
      showSendPro: true,
      // 是否显示- 发起众筹
      teamfund_total: 0,
      // 一起筹数量
      loading: true,
      ideaLoading: true,
      weapp: this.$route.query.weapp != "off",
      //是否打开自动调起小程序，默认是
      app_guide: this.$route.query.app_guide != "off",
      //是否打开APP引导下载，默认是
      mina_focus: this.$route.query.mina_focus == "true",
      //是否将用户购买行为强制改为调起小程序，默认否
      content_fold: this.$route.query.content_fold == "true",
      //是否折叠内容，默认否
      temp_id: this.$route.query.temp_id,
      // 详情预览的请求参数
      token: this.$route.query.token,
      // 详情预览的请求参数
      preview_id: this.$route.query.id,
      // 详情预览的请求参数
      version_id: this.$route.query.version_id || 0,
      // 详情预览的请求参数
      pro_draw_list: [],
      // 抽奖列表
      pro_id: null,
      // 项目ID
      isContentExpanded: false,
      // 富文本内容是否展开

      unique: '',
      // 点击分享

      showUnlockGoal: false,
      // 是否展示解锁目标
      goalUnlockList: [],
      // 解锁档列表
      goalUnlockListShow: [],
      // 解锁档列表--详情页展示数据
      giveaway_type: null,
      showUnlockGoalTips: false,
      // 是否展示解锁目标提示
      unlockGoalTipsItem: {},
      // 传给解锁目标提示弹层的信息
      statusMap: {
        "100": "努力中",
        "200": "已达成",
        "300": "未达成"
      },
      conditionsBtnMap: {
        '1': '去购买',
        '2': '去分享',
        '3': '去邀请'
      },
      utmObj: {}
    };
  },
  watch: {
    // 监听路由参数变化
    '$route'(to, from) {
      // 如果是同一个组件但参数不同，重新加载数据
      if (to.params.id !== from.params.id) {
        console.log('路由参数变化，重新加载:', to.params.id);
        this.reloadPage();
      }
    }
  },
  async beforeMount() {
    // ========== 临时代码开始 - 项目ID 151305 特殊处理 ==========
    // TODO: 临时代码，计算content_fold的值
    const projectId = parseInt(this.$route.params.id);
    console.log('projectId', projectId);
    console.log('this.$route.query.content_fold', this.$route.query.content_fold);
    if (projectId == '151305') {
      // 项目151305：除非明确设置为false，否则默认为true
      this.content_fold = this.$route.query.content_fold !== "false";
    } else {
      // 其他项目：只有明确设置为true才启用
      this.content_fold = this.$route.query.content_fold == "true";
    }
    // ========== 临时代码结束 ==========

    // eslint-disable-next-line no-undef
    userHeader.openapp.style.bottom = "70px";
    // 和家亲APP特殊处理 - SDK初始化
    if (this.$route.query.fromApp === 'hejiaqin' && !this.ifLogin) {
      const result = await initHejiaqinSDK();
      if (result.success) {
        console.log('和家亲SDK初始化成功:', result.data);
      } else {
        console.warn('和家亲SDK初始化失败，继续正常流程:', result.error);
        // 失败时不阻断路由，继续正常加载页面
      }
    }
    if (this.is_preview) {
      this.ideaLoading = false;
      await this.getPreviewInfo();
      this.loading = false;
    } else {
      const pro_id = this.$route.params.id ? parseInt(this.$route.params.id) : "";
      this.pro_id = pro_id;

      // 点击分享
      this.unique = this.$route.query.unique ? this.$route.query.unique : "";
      if (this.unique) {
        this.clickShare();
      }
      await this.getInfo();
      this.loading = false;

      // 打点
      this.sensors.track("ProDetail", {
        page_source: "",
        position_source: "",
        item_name: this.product_info.name || "",
        item_id: this.pro_id || "",
        sec_business_line: this.product_info.pro_class || "",
        category: this.product_info.category || "",
        product_name: "",
        spu_id: "",
        sku_id: "",
        store_id: "",
        brand: ""
      });
      this.setShare();

      // eslint-disable-next-line no-undef
      userHeader.getMdlink({
        type: "project",
        id: pro_id
      });
    }
    // 获取解锁档数据
    this.getUnlockGoalData();

    // 通过用户分享的项目详情进入
    const {
      utm_campaign,
      utm_source,
      utm_medium,
      utm_term,
      utm_content
    } = this.$route.query;
    utm_campaign && (this.utmObj.utm_campaign = utm_campaign);
    utm_source && (this.utmObj.utm_source = utm_source);
    utm_medium && (this.utmObj.utm_medium = utm_medium);
    utm_term && (this.utmObj.utm_term = utm_term);
    utm_content && (this.utmObj.utm_content = utm_content);

    // 通过用户分享的项目详情进入
    if (['Appshare', 'Minashare', 'Othershare'].includes(utm_source)) {
      clickUserShareProIndex(this.utmObj);
    }
  },
  unmounted() {
    // eslint-disable-next-line no-undef
    userHeader.openapp.style.bottom = "0.27rem";
  },
  methods: {
    // 获取预览的众筹详情
    async getPreviewInfo() {
      const {
        status,
        data,
        message
      } = await previewProject({
        pro_id: this.preview_id,
        temp_id: this.temp_id,
        token: this.token,
        version_id: this.version_id
      });
      if (status != 0) {
        this.showError = true;
        this.showMessage = message || "项目不存在";
        return;
      } else {
        this.product_info = data.project_info;
        this.product_info.name = data.project_info.title;
        this.product_info.username = data.cp_user_info.user_name;
        this.product_info.user_icon = data.cp_user_info.user_icon;
        // this.product_info.left_time = data.project_info.end_time ? data.project_info.end_time.split(' ')[0] : '';
        this.product_info.is_preview = true;
        this.product_info.reward_list = data.reward_list;
        this.user_info = data.cp_user_info;
        this.$refs.editorBox.appendChild(cont_match_reg(`<p>${data.project_info.content}</p>`));
        this.$nextTick(() => {
          observeVideo(this.$refs.editorBox, process.env.VUE_APP_ENV);
        });
      }
    },
    // 获取众筹详情
    async getInfo() {
      // 获取基础项目信息
      const {
        status,
        data,
        message
      } = await getProjectBasicInfo({
        pro_id: this.pro_id
      });
      if (status != 0) {
        this.showError = true;
        this.showMessage = message || "项目不存在";
        return;
      } else {
        // ********** 标记为非详情预览 **********

        // 非预览
        this.product_info.is_preview = false;
        // 回报档列表
        this.product_info.reward_list = [];

        // ********** 众筹详情 **********

        // 获取基础项目信息
        this.product_info = data.product_info || {};

        // 更新信息
        this.update_info = data.update_info || {};

        // 抽奖列表
        this.pro_draw_list = data.product_info.draw_list || [];
        this.ideaLoading = false;

        // 获取基础项目信息-动态数据-剩余时间等
        this.getProjectInfoTR();

        // 获取富文本内容
        this.getProjectContent();

        // 获取众筹次关联数据-可降级
        this.getProjectInfoRelate();
        if (data.product_info.pro_class == '102' && this.idea_info.idea_id) {
          return this.$router.replace(`/idea/${this.idea_info.idea_id}`);
        }

        // 获取众筹详情用户关联数据-可降级
        this.getProjectInfoDynamic();

        // 获取小程序链接
        if (this.weapp && this.product_info.is_forbidden != 1) {
          this.getWxScheme();
        }

        // 获取一起筹数据
        if (this.product_info.status_code != 4 && this.product_info.status_code != 1) {
          this.getTeamfund();
        }

        // 常见问题
        if (this.product_info.question_url) {
          this.getQuestionList();
        }
      }
    },
    // 动态接口-剩余时间等 OK
    async getProjectInfoTR() {
      const {
        status,
        data
      } = await getProjectBasicInfoRT({
        pro_id: this.pro_id
      });
      if (status == 0) {
        this.product_info = Object.assign(this.product_info, data.product_info || {});
        this.update_info = Object.assign(this.update_info, data.update_info || {});
      }
    },
    // 获取富文本内容 OK
    async getProjectContent() {
      const _this = this;
      const {
        status,
        data
      } = await getProjectBasicContent({
        pro_id: this.pro_id
      });
      if (status == 0) {
        this.product_info = {
          ...this.product_info,
          ...data
        };
        _this.$nextTick(() => {
          if (!_this.showError && _this.$refs.editorBox) {
            _this.$refs.editorBox.appendChild(cont_match_reg(`<p>${data.content}</p>`));
            _this.$nextTick(() => {
              observeVideo(_this.$refs.editorBox, process.env.VUE_APP_ENV);
            });
          }
        });
      }
    },
    // 获取众筹次关联数据-可降级 OK
    async getProjectInfoRelate() {
      const {
        status,
        data
      } = await getProjectBasicRelateInfo({
        pro_id: this.pro_id
      });
      if (status == 0) {
        this.rank_info = data.rank_info;
        this.idea_info = data.idea_info;
        this.user_info = data.cp_user_info;
        this.product_info.member_count = data.member_count;
        this.product_info.favor_count = data.favor_count;
        this.product_info.warning_txt = data.warning_txt;
      }
    },
    // 获取众筹详情用户关联数据-可降级
    async getProjectInfoDynamic() {
      const {
        status,
        data
      } = await getProjectBasicDynamicInfo({
        pro_id: this.pro_id
      });
      if (status == 0) {
        this.product_info = Object.assign(this.product_info, data.product_info || {});
        this.update_info = Object.assign(this.update_info, data.update_info || {});
      }
    },
    // 获取常见问题
    async getQuestionList() {
      const {
        status,
        data
      } = await getQuestionlist({
        project_id: this.pro_id,
        page_size: 2
      });
      if (status == 0) {
        this.question_list = data.list;
        this.question_total = data.total;
      }
    },
    goQuestionList() {
      location.href = this.product_info.question_url;
    },
    // 查看更新列表
    goUpdateList() {
      MDRouter.goUpdateList({
        pro_id: this.pro_id
      });
    },
    // 查看更新详情
    goUpdateInfo() {
      MDRouter.goUpdateDetail(this.update_info.id);
    },
    // 看好项目
    async onFavor() {
      if (this.is_preview) {
        return false;
      }
      console.log("this.product_info.if_favor", this.product_info.if_favor);
      if (!this.ifLogin) {
        return redirect.to("login");
      }
      if (this.product_info.if_favor) {
        // 取消看好
        this.favorType = "cancel";
        this.showFavor = true;
      } else {
        // 看好
        let obj = {
          user_id: this.userId,
          pro_id: this.pro_id
        };
        const utm_source = this.utmObj.utm_source;
        if (['Appshare', 'Minashare', 'Othershare'].includes(utm_source)) {
          obj.share_user_id = sessionStorage.getItem("utm_content") || '';
        }
        favorProject(obj).then(res => {
          if (res.status == 0) {
            this.product_info.if_favor = true;
            this.product_info.favor_count += 1;
          }
          res.message ? mdToast(res.message) : '';
        });
      }
    },
    // 取消看好
    cancelFavor() {
      let obj = {
        user_id: this.userId,
        pro_id: this.pro_id
      };
      const utm_source = this.utmObj.utm_source;
      if (['Appshare', 'Minashare', 'Othershare'].includes(utm_source)) {
        obj.share_user_id = sessionStorage.getItem("utm_content") || '';
      }
      favorProject(obj).then(res => {
        if (res.status == 0) {
          this.product_info.if_favor = false;
          this.product_info.favor_count -= 1;
          this.showFavor = false;
        }
        res.message ? mdToast(res.message) : '';
      });
    },
    // 看好数量
    formatFavorCount(num) {
      if (num) {
        if (num > 10000) {
          return (num / 10000).toFixed(2) + "万";
        } else {
          return num;
        }
      } else {
        return '--';
      }
    },
    // 复制发起众筹链接
    copySendProLink() {
      if (this.is_preview) {
        return false;
      }
      location.href = "https://account.modian.com/m/initiate";
    },
    // 关闭-发起众筹
    closeSendPro() {
      this.showSendPro = false;
    },
    // 获取一起筹数量
    getTeamfund() {
      getTeamfundTotal({
        pro_id: this.pro_id
      }).then(res => {
        if (res.status == 0) {
          this.teamfund_total = res.data.teamfund_total;
        }
      });
    },
    // 查看一起筹榜单/发起一起筹
    goTeamfund() {
      if (this.teamfund_total > 0) {
        // 查看一起筹榜单
        location.href = `${domain.wap}/teamfund/ranking_list/${this.pro_id}`;
      } else {
        // 发起一起筹
        location.href = `${domain.wap}/initiate/teamfund?pro_id=${this.pro_id}`;
      }
    },
    // 去app
    goToApp() {
      if (this.is_preview) {
        return false;
      }
      // eslint-disable-next-line no-undef
      location.href = userHeader.mdlink;
    },
    // 获取小程序scheme url
    async getWxScheme() {
      if (env.isMobile() && !(env.isWeibo() || env.isWxApp() || env.isModianIos() || env.isModianAndroid())) {
        let url = "";
        if (sessionStorage.getItem(this.pro_id)) {
          const obj = JSON.parse(sessionStorage.getItem(this.pro_id));
          let time = Number(obj.initial_time);
          const now = Number(Date.now());
          if (obj.scheme_url && now - time < 23 * 60 * 60 * 1000) {
            // 23小时失效
            url = obj.scheme_url;
          } else {
            url = await this.getScheme();
          }
        } else {
          url = await this.getScheme();
        }
        if (url) {
          location.href = url;
        }
      }
    },
    async getScheme() {
      // const query = this.$route.query || {}
      // for (let key in query) {
      //     str += `&${key}=${query[key]}`
      // }
      let str = window.location.search ? window.location.search.substr(1) : "";
      const param = {
        path: "/pages/project_detail/project_detail",
        query: `pro_id=${this.pro_id}&${str}`
      };
      const option = {
        jump_wxa: JSON.stringify(param)
      };
      var url = await getSchemeUrl(option);
      if (!url) return false;
      sessionStorage.setItem(this.pro_id, JSON.stringify({
        scheme_url: url,
        initial_time: Date.now()
      }));
      return url;
    },
    // 分享
    setShare() {
      let url = `${domain.wap}/project/${this.pro_id}.html?&utm_source=Othershare&utm_content=${this.userId}&utm_term=${this.pro_id}&utm_campaign=projec`;
      let share_option = {
        url,
        img: this.product_info.logo,
        msg_des: `我在摩点网发现一个有意思的众筹项目：【${this.product_info.title}】看看是否感兴趣？${url}`,
        qq_des: this.product_info.title,
        qq_share_url: `${url}`,
        qq_title: this.product_info.title,
        qr_img: "",
        qzone_share_url: `${url}`,
        share_channel: "",
        share_url: `${url}`,
        sharelink_url: `${url}`,
        weibo_des: `我在摩点网发现一个有意思的众筹项目：【${this.product_info.title}】看看是否感兴趣？${url}（分享自@摩点）`,
        weibo_share_url: `${url}`,
        weibo_title: "",
        weixin_share_url: `${url}`,
        wxTimeline_share_url: `${url}`,
        wx_des: this.product_info.title,
        wx_title: ""
      };
      // eslint-disable-next-line no-undef
      userHeader.setShareInfo(share_option);
    },
    // 分享---复制链接
    copyShareLink() {
      const url = `${domain.wap}/project/${this.pro_id}.html?&utm_source=Othershare&utm_content=${this.userId}&utm_term=${this.pro_id}&utm_campaign=project`;
      QuickCopy(url);
    },
    goCategoryList(item) {
      window.location.href = item.h5_link;
    },
    // 点击分享
    clickShare() {
      ClickShare({
        unique_id: this.unique
      });
    },
    // 查看3C证书
    async showCertificateCcc() {
      const {
        data,
        status,
        message
      } = await getQueryUserLicenseInfo3c({
        pro_id: this.pro_id
      });
      if (status == 0 && data && data.list && data.list.length) {
        showImagePreview(data.list.map(item => item.file_url));
      } else {
        mdToast(message);
      }
    },
    // 解锁档 ---- 
    // 计算是否在”努力中“ 
    getIng(item) {
      if (item.status == 100) {
        const isIng = item.conditions.some(raskItem => {
          return raskItem.type == 1 && raskItem.is_completed == 1;
        });
        return isIng;
      }
      return false;
    },
    // 获取解锁档数据
    async getUnlockGoalData() {
      const {
        data,
        status
      } = await getProIndexUnlockGoal({
        pro_id: this.pro_id
      });
      if (status == 0 && data) {
        const index_show_goal_unlock = data.index_show_goal_unlock;
        this.goalUnlockListShow = [index_show_goal_unlock];
        this.goalUnlockList = data.list;
        this.giveaway_type = data.giveaway_type;

        // 任务努力中且只有一项未完成，显示“分享”按钮
        if (this.getIng(index_show_goal_unlock)) {
          const uncompletedTasks = index_show_goal_unlock.conditions.filter(task => task.is_completed === 0);
          if (uncompletedTasks.length === 1) {
            const index = index_show_goal_unlock.conditions.findIndex(task => task.is_completed === 0);
            this.unlockGoalTipsItem = {
              ...index_show_goal_unlock.conditions[index],
              img: index_show_goal_unlock.prizes[0].img
            };
            this.showUnlockGoalTips = true;
          } else {
            this.showUnlockGoal = false;
          }
        } else {
          this.showUnlockGoalTips = false;
        }
      }
    },
    taskAction() {
      this.copyShareLink();
    },
    showUnlockGoalAction() {
      if (!this.ifLogin) {
        return redirect.to("login");
      }
      this.showUnlockGoal = true;
    },
    fNum(num) {
      return fmoney(num, 2);
    },
    // 重新加载页面数据
    async reloadPage() {
      // ========== 临时代码开始 - 项目ID 151305 特殊处理 ==========
      // TODO: 临时代码，重新计算content_fold的值
      const projectId = this.$route.params.id;
      if (projectId == '151305') {
        // 项目151305：除非明确设置为false，否则默认为true
        this.content_fold = this.$route.query.content_fold !== "false";
      } else {
        // 其他项目：只有明确设置为true才启用
        this.content_fold = this.$route.query.content_fold == "true";
      }
      // 重置展开状态
      this.isContentExpanded = false;
      // ========== 临时代码结束 ==========

      // 重置数据
      this.showError = false;
      this.showMessage = "";
      this.product_info = {};
      this.update_info = {};
      this.user_info = {};
      this.idea_info = {};
      this.rank_info = {};
      this.question_list = [];
      this.question_total = 0;
      this.loading = true;
      this.ideaLoading = true;

      // 更新 pro_id
      const pro_id = this.$route.params.id ? parseInt(this.$route.params.id) : "";
      this.pro_id = pro_id;

      // 重新加载数据
      await this.getInfo();
      this.loading = false;

      // 重新设置分享
      this.setShare();

      // 重新获取解锁档数据
      this.getUnlockGoalData();

      // 滚动到顶部
      window.scrollTo(0, 0);
    },
    // 展开富文本内容
    expandContent() {
      this.isContentExpanded = true;
    }
  }
};